import React, { Component } from 'react';
import PropTypes from 'prop-types';
import numeral from 'numeral';
import { VictoryChart, VictoryLine, VictoryScatter, VictoryAxis, VictoryTooltip, VictoryZoomContainer, VictoryBrushContainer, VictoryLabel } from 'victory';
import theme from 'themes/victoryChartTheme';

const ZoomedChart = props => {
  let { width, height } = props.chartSize;
  return (
    <VictoryChart width={width*0.9} height={height*0.70} theme={theme}
      domainPadding={{x:2, y:[0,5]}}
      containerComponent={
        <VictoryZoomContainer
          style={{paddingLeft: '20px'}}
          minimumZoom={{x:10}}
          allowZoom={false}
          zoomDimension="x"
          zoomDomain={props.zoomDomain}
          onZoomDomainChange={props.handleZoom}
        />
      }
    >
      {/* Axis for Zoom Chart */}
      <VictoryAxis
        label={props.unit}
        style={{
          axisLabel: {fontSize: 10, color: '#EEE', padding: 35},
        }}
        tickCount={10} />
      <VictoryAxis
        animate={{
          duration: 500,
          onLoad: { duration: 500 }
        }}
        dependentAxis
        tickCount={6}
        tickFormat={(x) => numeral(x).format('$0a')}
      />
      {/* Conditional Render of Line and Scatter Chart for SERIES1*/}
      { props.series1Data &&
        <VictoryLine
          animate={{
            duration: 300,
            onLoad: { duration: 300 }
          }}
          style={{
            data: {stroke: props.colors['series1']}
          }}
          labelComponent={<VictoryTooltip/>}
          data={props.series1Data}
          x="index"
          y="value" />
      }
      { props.series1Data &&
        <VictoryScatter
          animate={{
            duration: 300,
            onLoad: { duration: 300 }
          }}
          size={(datum) => {
            if (datum.value === 0) return 0;
            else return 4;
          }}
          style={{
            data: {fill: props.colors['series1']}
          }}
          labelComponent={
            <VictoryTooltip text={(datum) => {
              if(datum.value) {
                return (props.labelUnit === 'Day')
                ? `${props.labelUnit} ${datum.index} - ${numeral(datum.value).format('$0,0.00')}\n${datum.startDate}`
                : `${props.labelUnit} ${datum.index} - ${numeral(datum.value).format('$0,0.00')}\n${datum.startDate} - ${datum.endDate}`
              }
            }}/>
          }
          data={props.series1Data}
          x="index"
          y="value" />
      }
      {/* Conditional Render of Line and Scatter Chart for SERIES2  */}
      { (props.selectedSeries2 && props.series2Data) &&
        <VictoryLine
          animate={{
            duration: 300,
            onLoad: { duration: 300 }
          }}
          style={{
            data: {stroke: props.colors['series2']}
          }}
          labelComponent={<VictoryTooltip/>}
          data={props.series2Data}
          x="index"
          y="value" />
      }
      { (props.selectedSeries2 && props.series2Data) &&
        <VictoryScatter
          animate={{
            duration: 300,
            onLoad: { duration: 300 }
          }}
          size={(datum) => {
            if (datum.value === 0) return 0;
            else return 4;
          }}
          style={{
            data: {fill: props.colors['series2']}
          }}
          labelComponent={
            <VictoryTooltip text={(datum) => {
              if(datum.value) {
                return (props.labelUnit === 'Day')
                ? `${props.labelUnit} ${datum.index} - ${numeral(datum.value).format('$0,0.00')}\n${datum.startDate}`
                : `${props.labelUnit} ${datum.index} - ${numeral(datum.value).format('$0,0.00')}\n${datum.startDate} - ${datum.endDate}`
              }
            }}/>
          }
          data={props.series2Data}
          x="index"
          y="value" />
      }
      {/* Conditional Render of Line and Scatter Chart for SERIES3  */}
      { (props.selectedSeries3 && props.series3Data) &&
        <VictoryLine
          animate={{
            duration: 300,
            onLoad: { duration: 300 }
          }}
          style={{
            data: {stroke: props.colors['series3']}
          }}
          labelComponent={<VictoryTooltip/>}
          data={props.series3Data}
          x="index"
          y="value" />
      }
      { (props.selectedSeries3 && props.series3Data) &&
        <VictoryScatter
          animate={{
            duration: 300,
            onLoad: { duration: 300 }
          }}
          size={(datum) => {
            if (datum.value === 0) return 0;
            else return 4;
          }}
          style={{
            data: {fill: props.colors['series3']}
          }}
          labelComponent={
            <VictoryTooltip text={(datum) => {
              if(datum.value) {
                return (props.labelUnit === 'Day')
                ? `${props.labelUnit} ${datum.index} - ${numeral(datum.value).format('$0,0.00')}\n${datum.startDate}`
                : `${props.labelUnit} ${datum.index} - ${numeral(datum.value).format('$0,0.00')}\n${datum.startDate} - ${datum.endDate}`
              }
            }}/>
          }
          data={props.series3Data}
          x="index"
          y="value" />
      }
    </VictoryChart>
  )
}

export default ZoomedChart;



// WEBPACK FOOTER //
// ./src/scripts/components/series/seriesComparison/ZoomedChart.js